import { gsap, SplitText } from 'gsap/all'
gsap.registerPlugin(SplitText)

interface SplitTitle {
  lines: Element[]
  destroy(): void
}

export const setSplitTitle = (title: HTMLElement): SplitTitle => {
  // Store the original text
  const originalText = title.textContent

  const newText = new SplitText(title, {
    type: 'lines, words',
    linesClass: 'lineChild'
  })
  const innerText = new SplitText(title, {
    type: 'lines',
    linesClass: 'lineParent'
  })

  // Additional animations can be added here if needed
  gsap.set(newText.lines, { yPercent: 100 })

  // On resize change, restore the original content
  window.addEventListener('resize', () => {
    title.textContent = originalText
  })

  const destroy = () => {
    if (newText) newText.revert()
    if (innerText) innerText.revert()
  }

  return {
    lines: [...newText.lines],
    destroy
  }
}
